import React from 'react'
import { I18n } from '@lingui/react'
import { t } from '@lingui/macro'
import { UtilityElectricity, UtilityGas, UtilityWater } from '@conserveit/blocks'
import { MetricsType } from '../../../../context/reports/utilities/types'
import * as Sidebar from '../../SideBar.styles'
import { navigate } from '../../../../utils/routes/navigate'
import { Route } from '../../../../utils/routes/reports'

interface Props {
  active: MetricsType
  siteId?: string
}

function getRoute (type: MetricsType, siteId?: string) {
  let route = `${Route.UtilitiesPortfolio}/${type.toLowerCase()}`
  if (siteId) {
    route = `${route}/${siteId}`
  }

  return route
}

export const ActionsBar: React.FC<Props> = ({ active, siteId }) => (
  <I18n>
    {({ i18n }) => (
      <Sidebar.List>
        <Sidebar.ListItem
          onClick={navigate(getRoute(MetricsType.Electricity, siteId))}
          isActive={active === MetricsType.Electricity}
        >
          <UtilityElectricity outline />
          <Sidebar.Link disabled={active === MetricsType.Electricity}>{i18n._(t('reports.electricity_usage')`Electricity usage`)}</Sidebar.Link>
        </Sidebar.ListItem>
        <Sidebar.ListItem
          onClick={navigate(getRoute(MetricsType.Gas, siteId))}
          isActive={active === MetricsType.Gas}
        >
          <UtilityGas outline />
          <Sidebar.Link disabled={active === MetricsType.Gas}>{i18n._(t('reports.gas_usage')`Gas usage`)}</Sidebar.Link>
        </Sidebar.ListItem>
        <Sidebar.ListItem
          onClick={navigate(getRoute(MetricsType.Water, siteId))}
          isActive={active === MetricsType.Water}
        >
          <UtilityWater outline />
          <Sidebar.Link disabled={active === MetricsType.Water}>{i18n._(t('reports.water_usage')`Water usage`)}</Sidebar.Link>
        </Sidebar.ListItem>
      </Sidebar.List>
    )}
  </I18n>
)
